import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/** Routes that share AgentHomeChatComponent as their host component.
 *  When navigating between any two paths in this set, Angular reuses the
 *  existing component instance instead of destroying and recreating it —
 *  so the sidebar remains mounted and the WebSocket connection is preserved.
 *  (The Data Hub is its own full-screen route, not part of the chat shell, so
 *  it is intentionally absent here.) */
const SHARED_CHAT_SHELL_PATHS = new Set(['chat']);

@Injectable()
export class ChatReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    if (
      SHARED_CHAT_SHELL_PATHS.has(future.routeConfig?.path ?? '') &&
      SHARED_CHAT_SHELL_PATHS.has(curr.routeConfig?.path ?? '')
    ) {
      return true;
    }
    return super.shouldReuseRoute(future, curr);
  }
}
